<template>
  <div>
    <h1>Forgot Password</h1>
    <p>Enter your email to reset your password</p>
    <form v-on:submit.prevent="submit">
      <input ref="email" type="email" v-model="email" />
      <input type="submit" value="Submit" />
    </form>

  </div>
</template>

<script>
import API from '@/data/api.js'
import {store} from '@/store'

export default {
  name: 'ForgotPassword',
  data () {
    return {
      email: null
    }
  },
  mounted () {
    this.$refs.email.focus()
  },
  methods: {
    async submit () {
      try {
        await API.sendPasswordReset(this.$refs.email.value)
        store.commit('setAlert', {
          message: 'If your email belongs to an Everyday user, we have sent a reset link',
          type: 'message'
        })
      } catch (e) {
        store.commit('setAlert', {
          message: e.response.data.message,
          type: 'warning'
        })
      }
    }
  }
}

</script>

<style scoped>
  input[type="submit"] {
    height: 36px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/auth/ForgotPassword.vue